import { IconProps } from './icon-props';

export const Logout = ({ ...props }: IconProps) => (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    strokeWidth="1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.93438 15.1022H8.98757C9.29806 15.1022 9.54902 15.3532 9.54902 15.6637C9.54902 15.9742 9.29806 16.2251 8.98757 16.2251H3.93438C3.00572 16.2251 2.25 15.4694 2.25 14.5407V4.43441C2.25 3.50575 3.00572 2.75 3.93438 2.75H8.98757C9.29806 2.75 9.54902 3.00102 9.54902 3.3115C9.54902 3.62199 9.29806 3.87296 8.98757 3.87296H3.93438C3.62448 3.87296 3.37293 4.12448 3.37293 4.43441V14.5408C3.37293 14.8507 3.62445 15.1022 3.93438 15.1022ZM12.189 5.71897L15.6027 9.08775C15.71 9.19388 15.77 9.33706 15.77 9.48747C15.77 9.63793 15.7094 9.78169 15.6027 9.88723L12.189 13.256C12.0801 13.3638 11.9375 13.4177 11.7949 13.4177C11.65 13.4177 11.5052 13.3616 11.3951 13.2504C11.1779 13.0298 11.1795 12.6744 11.4007 12.4565L13.8403 10.049H7.30317C6.99269 10.049 6.74172 9.79798 6.74172 9.48749C6.74172 9.17701 6.99269 8.92604 7.30317 8.92604H13.8403L11.4007 6.5185C11.1795 6.30065 11.1773 5.94524 11.3951 5.72459C11.613 5.50394 11.9689 5.50112 12.189 5.71897Z"
      fill="#1E1E1E"
      strokeWidth="1"
    />
  </svg>
);
